import AddIcon from "@material-ui/icons/Add";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import SectionCard from "./SectionCard";
import classes from "./WelcomeSection.module.scss";
import { CAMPAIGN_STEPS } from "../../../../types/campaignTypes";
import { ROUTE_PATHS } from "../../../../types/RoutePaths";
import { ReduxApplicationState } from "../../../../types/ReduxTypes/ReduxApplicationState";
import { setCampaignSteps } from "../../../../redux/reducers/campaignToCreate";

type HandleSectionClickParams = {
  navigateUrl: string;
  campaignSteps?: string[];
  title?: string;
  isDynamicABA?: boolean;
};

const WelcomeSection = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const allPlayBooks = useSelector((state: ReduxApplicationState) => state.agency.playbooks);
  // CRM Re-targeting Segments disabled: hide playbooks that include this step
  const playBooks = allPlayBooks?.filter((pb) => !pb.campaignSteps?.includes(CAMPAIGN_STEPS.CRM_RETARGETING_SEGMENTS));

  const handleSectionClick =
    ({ navigateUrl, campaignSteps, title, isDynamicABA = false }: HandleSectionClickParams) =>
    () => {
      sessionStorage.clear();

      localStorage.setItem("isDynamicABA", isDynamicABA.toString());

      if (campaignSteps) {
        dispatch(setCampaignSteps(campaignSteps as CAMPAIGN_STEPS[]));
      }
      history.push({
        pathname: navigateUrl,
        state: { title },
      });
    };

  return (
    <div className={classes.container}>
      {playBooks &&
        playBooks.length > 0 &&
        playBooks.map((playBook) => (
          <SectionCard
            key={playBook.id}
            icon={playBook.icon}
            title={playBook.title}
            description={playBook.description}
            buttonTitle="Create"
            buttonIcon={<AddIcon />}
            handleClick={handleSectionClick({
              navigateUrl: ROUTE_PATHS.MANAGED_CAMPAIGN_CREATE,
              campaignSteps: playBook.campaignSteps,
              title: playBook.title,
            })}
          />
        ))}

      <SectionCard
        icon="TopMiddleBottomIcon"
        title="Dynamic Account-Based Advertising"
        description={[
          "Build the campaign structure within BrandGen.io such as titles, creative and landing pages.",
          "Use HubSpot Workflows to control the target accounts, activate and deactivate campaigns against companies dynamically. This enables you to align marketing and sales so that your air cover is in alignment with sales and marketing motions.",
          "You can also progress buying groups at target accounts through a series of campaigns using HubSpot Workflows.",
        ]}
        buttonTitle="Create"
        buttonIcon={<AddIcon />}
        handleClick={handleSectionClick({
          navigateUrl: ROUTE_PATHS.CUSTOM_CAMPAIGN_CREATE,
          isDynamicABA: true,
        })}
      />

      <SectionCard
        icon="TopMiddleBottomIcon"
        title="Custom Campaigns"
        description={[
          "Take control of your audience creation by selecting your own mix of targeting attributes from our available options.",
          "The option selections are ‘And’, so each selection narrows your audience by that attribute.",
          "Questions on targeting strategies? Ask us here.",
        ]}
        buttonTitle="Create"
        buttonIcon={<AddIcon />}
        handleClick={handleSectionClick({
          navigateUrl: ROUTE_PATHS.CUSTOM_CAMPAIGN_CREATE,
        })}
      />
    </div>
  );
};

export default WelcomeSection;
